var _desc, _defs, _rect, _text, _text2, _text3, _g, _g2, _g3, _g4, _path, _g5, _text4, _text5, _text6, _text7, _text8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiagramStakeholders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 880 720",
    width: 880,
    height: 720,
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, "Stakeholders by distance from the team") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "d"
  }, "A dartboard with the team at the centre and three rings: inner (sees the work weekly), middle (monthly, via a slide) and outer (rarely or never). Illustrative stakeholders are plotted as markers by stance; large markers can say no. Dashed arrows show moves that pull the powerful outer-ring people closer: a show and tell invite, a coffee, weeknotes.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: "-10%",
    y: "-10%",
    width: "130%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 1,
    dy: 2,
    stdDeviation: 1.6,
    floodColor: "#0b0b0b",
    floodOpacity: 0.18
  })), /*#__PURE__*/React.createElement("marker", {
    id: "arrow",
    viewBox: "0 0 10 10",
    refX: 8,
    refY: 5,
    markerWidth: 7,
    markerHeight: 7,
    orient: "auto-start-reverse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L10,5 L0,10 z",
    fill: "#52514e"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 880,
    height: 720,
    fill: "#fcfcfb"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 38,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 20,
    fontWeight: 700,
    fill: "#0b0b0b",
    textAnchor: "start"
  }, "Stakeholders by distance from the team")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 62,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 400,
    fill: "#52514e",
    textAnchor: "start"
  }, "Write people where they actually are, not where they should be.")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 81,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 400,
    fill: "#898781",
    textAnchor: "start",
    fontStyle: "italic"
  }, "Illustrative roles, not real people.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rings"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 330,
    cy: 400,
    r: 272,
    fill: "#f6f5f1",
    stroke: "#c3c2b7",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 330,
    cy: 400,
    r: 182,
    fill: "#f1f0eb",
    stroke: "#c3c2b7",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 330,
    cy: 400,
    r: 92,
    fill: "#ebeae4",
    stroke: "#c3c2b7",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 330,
    cy: 400,
    r: 38,
    fill: "#0b0b0b"
  }), /*#__PURE__*/React.createElement("text", {
    x: 330,
    y: 398,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#fcfcfb",
    textAnchor: "middle"
  }, "The"), /*#__PURE__*/React.createElement("text", {
    x: 330,
    y: 414,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#fcfcfb",
    textAnchor: "middle"
  }, "team"), /*#__PURE__*/React.createElement("text", {
    x: 330,
    y: 326,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#52514e",
    textAnchor: "middle"
  }, "INNER: every week"), /*#__PURE__*/React.createElement("text", {
    x: 330,
    y: 238,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#52514e",
    textAnchor: "middle"
  }, "MIDDLE: monthly, via a slide"), /*#__PURE__*/React.createElement("text", {
    x: 330,
    y: 150,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#52514e",
    textAnchor: "middle"
  }, "OUTER: rarely or never"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "stakeholders"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 268,
    cy: 377.4,
    r: 11,
    fill: "#1baf7a",
    stroke: "#0b0b0b",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 252,
    y: 382.4,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#0b0b0b",
    textAnchor: "end"
  }, "Product owner"), /*#__PURE__*/React.createElement("circle", {
    cx: 387.2,
    cy: 367,
    r: 6,
    fill: "#1baf7a",
    stroke: "#0b0b0b",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 403.2,
    y: 372,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 400,
    fill: "#0b0b0b",
    textAnchor: "start"
  }, "Service owner"), /*#__PURE__*/React.createElement("circle", {
    cx: 323.9,
    cy: 469.7,
    r: 6,
    fill: "#1baf7a",
    stroke: "#0b0b0b",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 339.9,
    y: 474.7,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 400,
    fill: "#0b0b0b",
    textAnchor: "start"
  }, "Embedded tester"), /*#__PURE__*/React.createElement("rect", {
    x: 197.8,
    y: 459,
    width: 22,
    height: 22,
    fill: "#c3c2b7",
    stroke: "#0b0b0b",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 192.8,
    y: 475,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#0b0b0b",
    textAnchor: "end"
  }, "Budget holder"), /*#__PURE__*/React.createElement("circle", {
    cx: 456.9,
    cy: 459.2,
    r: 6,
    fill: "#1baf7a",
    stroke: "#0b0b0b",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 472.9,
    y: 464.2,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 400,
    fill: "#0b0b0b",
    textAnchor: "start"
  }, "Head of Product"), /*#__PURE__*/React.createElement("rect", {
    x: 276.1,
    y: 262.4,
    width: 12,
    height: 12,
    fill: "#c3c2b7",
    stroke: "#0b0b0b",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 266.1,
    y: 273.4,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 400,
    fill: "#0b0b0b",
    textAnchor: "end"
  }, "Steering group"), /*#__PURE__*/React.createElement("polygon", {
    points: "446.0,185.3 459.8,210.1 432.2,210.1",
    fill: "#eb6834",
    stroke: "#0b0b0b",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 462,
    y: 204.1,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#0b0b0b",
    textAnchor: "start"
  }, "Head of Security"), /*#__PURE__*/React.createElement("rect", {
    x: 113.7,
    y: 296,
    width: 12,
    height: 12,
    fill: "#c3c2b7",
    stroke: "#0b0b0b",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 103.7,
    y: 307,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 400,
    fill: "#0b0b0b",
    textAnchor: "end"
  }, "Legal"), /*#__PURE__*/React.createElement("polygon", {
    points: "182.2,568.7 189.7,582.2 174.7,582.2",
    fill: "#eb6834",
    stroke: "#0b0b0b",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 166.2,
    y: 581.2,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 400,
    fill: "#0b0b0b",
    textAnchor: "end"
  }, "Procurement"), /*#__PURE__*/React.createElement("polygon", {
    points: "465.4,579.6 479.1,604.3 451.6,604.3",
    fill: "#eb6834",
    stroke: "#0b0b0b",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 481.4,
    y: 598.3,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#0b0b0b",
    textAnchor: "start"
  }, "Head of the team next door"), /*#__PURE__*/React.createElement("rect", {
    x: 523.4,
    y: 271,
    width: 22,
    height: 22,
    fill: "#c3c2b7",
    stroke: "#0b0b0b",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 518.4,
    y: 287,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#0b0b0b",
    textAnchor: "end"
  }, "CEO\u2019s chief of staff"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "moves"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 441,
    y1: 207.7,
    x2: 410,
    y2: 261.4,
    stroke: "#2a78d6",
    strokeWidth: 2.4,
    strokeDasharray: "6 4",
    markerEnd: "url(#arrow)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 457.3,
    y1: 581.9,
    x2: 421.8,
    y2: 531.1,
    stroke: "#2a78d6",
    strokeWidth: 2.4,
    strokeDasharray: "6 4",
    markerEnd: "url(#arrow)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 522.3,
    y1: 289,
    x2: 468.6,
    y2: 320,
    stroke: "#2a78d6",
    strokeWidth: 2.4,
    strokeDasharray: "6 4",
    markerEnd: "url(#arrow)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-4 48 156)"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "Marker Felt, Chalkboard SE, Bradley Hand, Comic Sans MS, sans-serif",
    fontSize: 15,
    fontWeight: 400,
    fill: "#0b0b0b",
    textAnchor: "start"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 48,
    y: 156
  }, "The shit comes"), /*#__PURE__*/React.createElement("tspan", {
    x: 48,
    y: 174.8
  }, "from out here")))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150,176 q 30,30 40,62",
    fill: "none",
    stroke: "#52514e",
    strokeWidth: 1.8,
    markerEnd: "url(#arrow)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "legend"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 626,
    y: 120,
    width: 236,
    height: 248,
    rx: 4,
    fill: "#fff",
    stroke: "#e1e0d9"
  }), /*#__PURE__*/React.createElement("text", {
    x: 640,
    y: 144,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 700,
    fill: "#52514e",
    textAnchor: "start",
    letterSpacing: 1.2
  }, "STANCE"), /*#__PURE__*/React.createElement("circle", {
    cx: 648,
    cy: 168,
    r: 6,
    fill: "#1baf7a",
    stroke: "#0b0b0b",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 666,
    y: 173,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 400,
    fill: "#0b0b0b",
    textAnchor: "start"
  }, "Ally"), /*#__PURE__*/React.createElement("rect", {
    x: 642,
    y: 188,
    width: 12,
    height: 12,
    fill: "#c3c2b7",
    stroke: "#0b0b0b",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 666,
    y: 199,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 400,
    fill: "#0b0b0b",
    textAnchor: "start"
  }, "Neutral or unknown"), /*#__PURE__*/React.createElement("polygon", {
    points: "648.0,214.5 655.5,228.0 640.5,228.0",
    fill: "#eb6834",
    stroke: "#0b0b0b",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 666,
    y: 227,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 400,
    fill: "#0b0b0b",
    textAnchor: "start"
  }, "Sceptic"), /*#__PURE__*/React.createElement("text", {
    x: 640,
    y: 262,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 700,
    fill: "#52514e",
    textAnchor: "start",
    letterSpacing: 1.2
  }, "SIZE"), /*#__PURE__*/React.createElement("circle", {
    cx: 648,
    cy: 284,
    r: 11,
    fill: "#ecebe5",
    stroke: "#0b0b0b",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 666,
    y: 289,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#0b0b0b",
    textAnchor: "start"
  }, "Can say no"), /*#__PURE__*/React.createElement("circle", {
    cx: 648,
    cy: 312,
    r: 6,
    fill: "#ecebe5",
    stroke: "#0b0b0b",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 666,
    y: 317,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 400,
    fill: "#0b0b0b",
    textAnchor: "start"
  }, "Can\u2019t block you"), /*#__PURE__*/React.createElement("line", {
    x1: 638,
    y1: 346,
    x2: 662,
    y2: 346,
    stroke: "#2a78d6",
    strokeWidth: 2.4,
    strokeDasharray: "6 4",
    markerEnd: "url(#arrow)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 670,
    y: 351,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 400,
    fill: "#0b0b0b",
    textAnchor: "start"
  }, "This fortnight\u2019s move"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    fontFamily: "Marker Felt, Chalkboard SE, Bradley Hand, Comic Sans MS, sans-serif",
    fontSize: 15,
    fontWeight: 400,
    fill: "#0b0b0b",
    textAnchor: "start"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 626,
    y: 450
  }, "Big dots in the outer"), /*#__PURE__*/React.createElement("tspan", {
    x: 626,
    y: 468.8
  }, "ring are your to-do list."))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 400,
    fill: "#52514e",
    textAnchor: "start"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 626,
    y: 510
  }, "Surprise \u2248 power \xF7 distance."), /*#__PURE__*/React.createElement("tspan", {
    x: 626,
    y: 526.2
  }, "You can\u2019t change their"), /*#__PURE__*/React.createElement("tspan", {
    x: 626,
    y: 542.5
  }, "power. You can change"), /*#__PURE__*/React.createElement("tspan", {
    x: 626,
    y: 558.8
  }, "the distance."))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 437,
    y: 239.5,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#2a78d6",
    textAnchor: "start",
    fontStyle: "italic"
  }, "show and tell invite")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 451,
    y: 559.6,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#2a78d6",
    textAnchor: "start",
    fontStyle: "italic"
  }, "coffee")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 492.5,
    y: 327,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#2a78d6",
    textAnchor: "start",
    fontStyle: "italic"
  }, "weeknotes")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagramStakeholders);
export default __webpack_public_path__ + "static/media/diagram-stakeholders.0f377ba2f5d9681033ab51972755f392.svg";
export { ForwardRef as ReactComponent };